"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var EmailValidator = _interopRequireWildcard(require("email-validator"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _EditableField = _interopRequireDefault(require("./EditableField"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var MailIcon = function MailIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.413 7.003 12 12.592l5.587-5.59H6.413zM19 8.418l-6.293 6.295a1 1 0 0 1-1.414 0L5 8.418v8.59h14v-8.59zM3 7.003a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10.005a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7.002z"
  }));
};
MailIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var styles = {
  "icon": "AssetContactInfo__icon__26IAy",
  "is-editing": "AssetContactInfo__is-editing__3wZjK",
  "isEditing": "AssetContactInfo__is-editing__3wZjK",
  "metadata-item": "AssetContactInfo__metadata-item__1w-Om",
  "metadataItem": "AssetContactInfo__metadata-item__1w-Om",
  "mail": "AssetContactInfo__mail__14WXX",
  "separator": "AssetContactInfo__separator__17-Gw",
  "metadata-item-wrapper": "AssetContactInfo__metadata-item-wrapper__2hk2E",
  "metadataItemWrapper": "AssetContactInfo__metadata-item-wrapper__2hk2E"
}; 
require('./AssetContactInfo.css');
var validateEmail = function validateEmail(value) {
  var isValid = true;
  if (value === null || value === '') {
    isValid = true;
  } else {
    isValid = EmailValidator.validate(value);
  }
  return {
    isValid: isValid,
    errorMessage: isValid ? null : 'Invalid email address'
  };
};
var AssetContactInfo = function AssetContactInfo(_ref) {
  var _ref$contactName = _ref.contactName,
    contactName = _ref$contactName === void 0 ? null : _ref$contactName,
    _ref$contactEmail = _ref.contactEmail,
    contactEmail = _ref$contactEmail === void 0 ? null : _ref$contactEmail,
    _ref$onEditContactNam = _ref.onEditContactName,
    onEditContactName = _ref$onEditContactNam === void 0 ? function () {} : _ref$onEditContactNam,
    _ref$onEditContactEma = _ref.onEditContactEmail,
    onEditContactEmail = _ref$onEditContactEma === void 0 ? function () {} : _ref$onEditContactEma,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    _ref$isEditing = _ref.isEditing,
    isEditing = _ref$isEditing === void 0 ? false : _ref$isEditing;
  var _React$useState = _react.default.useState(),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    emailErrorMessage = _React$useState2[0],
    setEmailErrorMessage = _React$useState2[1];
  _react.default.useEffect(function () {
    setEmailErrorMessage(null);
  }, [isEditing]);
  var handleEditContactEmail = function handleEditContactEmail(_ref2) {
    var value = _ref2.value;
    var _validateEmail = validateEmail(value),
      isValid = _validateEmail.isValid,
      errorMessage = _validateEmail.errorMessage;
    if (isValid) {
      setEmailErrorMessage(null);
    }
    if (errorMessage) {
      setEmailErrorMessage(errorMessage);
    }
    onEditContactEmail({
      value: value,
      isValid: isValid
    });
  };
  if (isEditing || isDisabled) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.metadataItemWrapper, (0, _defineProperty2.default)({}, styles.isEditing, isEditing)),
      "data-test-id": "asset-contact-info-edit"
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      className: styles.icon,
      "aria-hidden": true
    }, /*#__PURE__*/_react.default.createElement(MailIcon, null)), /*#__PURE__*/_react.default.createElement(_EditableField.default, {
      fieldLabel: "Contact name",
      fieldValue: contactName,
      isDisabled: isDisabled,
      onChange: onEditContactName
    }), /*#__PURE__*/_react.default.createElement(_EditableField.default, {
      fieldLabel: "Contact email",
      fieldValue: contactEmail,
      isDisabled: isDisabled,
      isValid: !emailErrorMessage,
      errorMessage: emailErrorMessage,
      onChange: handleEditContactEmail
    }));
  }
  return contactName || contactEmail ? /*#__PURE__*/_react.default.createElement("div", {
    className: styles.metadataItemWrapper
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    className: styles.icon,
    "aria-hidden": true
  }, /*#__PURE__*/_react.default.createElement(MailIcon, null)), contactName ? /*#__PURE__*/_react.default.createElement("span", {
    "data-test-id": "asset-contact-info",
    className: styles.metadataItem
  }, contactName) : null, contactEmail ? /*#__PURE__*/_react.default.createElement("a", {
    href: "mailto:".concat(contactEmail),
    className: (0, _classnames.default)(styles.mail, (0, _defineProperty2.default)({}, styles.separator, contactName))
  }, contactEmail) : null) : null;
};
var _default = exports.default = AssetContactInfo;
//# sourceMappingURL=AssetContactInfo.js.map